






import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import blackLogo from 'images/padlet_logo_black.svg'
import whiteLogo from 'images/padlet_logo_white.svg'
import environment from 'bits/environment'
import { PADLET_HOSTS } from 'bits/url'

@Component
export default class PadletLogo extends Vue {
  @Prop({ default: false }) darkMode!: boolean

  get logo(): string {
    return this.darkMode ? whiteLogo : blackLogo
  }

  get homepageUrl(): string {
    return PADLET_HOSTS[environment] ? `https://${PADLET_HOSTS[environment].native}` : '/'
  }
}
